import React, { useState } from "react";
import { Header, Footer, Page } from "@/components/Shell";
import { API } from "@/lib/brand";
import axios from "axios";
import { toast } from "sonner";

export default function Retrieve() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try { await axios.post(`${API}/reports/retrieve`, { email }); setSent(true); }
    catch { toast.error("Une erreur est survenue."); }
  };

  return (
    <Page tone="ivory">
      <Header variant="ivory" />
      <section className="max-w-2xl mx-auto px-6 md:px-10 pt-24 pb-24" data-testid="retrieve-page">
        <div className="overline mb-6">Retrouver ma lecture</div>
        <h1 className="font-display text-[44px] md:text-[52px] leading-tight text-ink">Récupérer votre lien privé.</h1>
        <p className="mt-6 text-[18px] text-text-2 leading-relaxed">Entrez le courriel utilisé lors de votre lecture. Si un rapport existe, nous vous renverrons votre lien privé.</p>

        {!sent ? (
          <form onSubmit={submit} className="mt-12 space-y-8">
            <div>
              <label className="overline block mb-3">Courriel</label>
              <input type="email" required className="input-lux" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="vous@entreprise.com" data-testid="retrieve-email" />
            </div>
            <button type="submit" className="btn-primary" data-testid="retrieve-submit">Recevoir mon lien</button>
          </form>
        ) : (
          <div className="mt-12 border border-[color:var(--border-bronze)] bg-ivory-light p-8" data-testid="retrieve-confirmation">
            <div className="overline">Envoi effectué</div>
            <p className="mt-3 text-text-2 leading-relaxed">Si un rapport existe pour ce courriel, un lien vient d'y être envoyé.</p>
          </div>
        )}
      </section>
      <Footer />
    </Page>
  );
}
